import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side-description.vue';

@Component({
    mixins: [template],
})

export default class RightSideDescription extends Vue {

    @Prop(Object) readonly auctionData!: object;

    created() {

    }

    mounted() {

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-description/index.ts